module.exports = __webpack_public_path__ + "static/media/neptune-2.38232cf6.jpeg";